import { datadogRum } from '@datadog/browser-rum'
import { routingClient } from '../routing-client'

export interface Coordinates {
  latitude: number
  longitude: number
}

export const getCoordinates = async (
  postcode: string,
): Promise<Coordinates | undefined> => {
  try {
    const { data } = await routingClient.get<Coordinates>('/coordinates', {
      params: {
        postcode,
      },
    })

    return data
  } catch {
    datadogRum.addError(
      new Error(
        `Error fetching coordinates from logistics routing service for ${postcode}`,
      ),
    )
    return
  }
}
